import { BreakpointObserver } from '@angular/cdk/layout';
import {
  StepperOrientation,
  StepperSelectionEvent,
} from '@angular/cdk/stepper';
import { Location } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject, map } from 'rxjs';
import { CountrySelectionComponent } from 'src/app/shared/country-selection/country-selection.component';
import {
  CreditType,
  CreditTypeId,
} from 'src/app/shared/enums/credit-type.enum';
import { DataSelects } from 'src/app/shared/interfaces/data-selects';
import { GetDataService } from 'src/app/shared/services/get-data.service';
import { MapsInformationService } from 'src/app/shared/services/maps-information.service';
import { PutDataService } from 'src/app/shared/services/put-data.service';
import { RequestFormService } from 'src/app/shared/services/request-form.service';
import { RequestInformationComponent } from '../../shared/request-information/request-information.component';
import { HideToolbarService } from 'src/app/shared/services/hideToolbar.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent {
  @ViewChild('stepper') private stepper!: MatStepper;
  public stepperOrientation: Observable<StepperOrientation>;
  public enableInit = false;
  public enableWelcome = false;
  public enableWelcomeLto = false;
  public enableExperience = false;
  public enableWhereLiveCo = false;
  public enableAbout = false;
  public enableAboutYou = false;
  public enableDataUber = false;
  public enableDataUberLto = false;
  public enableDocuments = false;
  public enableMainDocumentsLto = false;
  public enableLoadDocuments = false;
  public enableMoreInformation = false;
  public enableDataValidationLto = false;
  public enableSecondaryDocumentsLto = false;
  public enableMoreInformationLto = false;

  public requestValueInit: Subject<boolean> = new Subject<boolean>();
  public requestValueWelcome: Subject<boolean> = new Subject<boolean>();
  public requestValueWelcomeLto: Subject<boolean> = new Subject<boolean>();
  public requestValueExperience: Subject<boolean> = new Subject<boolean>();
  public requestValueAboutYouCo: Subject<boolean> = new Subject<boolean>();
  public requestValueAboutYou: Subject<boolean> = new Subject<boolean>();
  public requestValueDataUber: Subject<boolean> = new Subject<boolean>();
  public requestValueDataUberLto: Subject<boolean> = new Subject<boolean>();
  public requestValueWhereLiveCo: Subject<boolean> = new Subject<boolean>();
  public requestValueDocuments: Subject<boolean> = new Subject<boolean>();
  public requestValueMainDocumentsLto: Subject<boolean> =
    new Subject<boolean>();
  public requestValueLoadDocuments: Subject<boolean> = new Subject<boolean>();
  public requestValueMoreInformation: Subject<boolean> = new Subject<boolean>();
  public requestValueMoreInformationLto: Subject<boolean> =
    new Subject<boolean>();
  public requestValueValidationDataLto: Subject<boolean> =
    new Subject<boolean>();
  public requestValueSecondaryDocumentsLto: Subject<boolean> =
    new Subject<boolean>();

  public creditType: string = sessionStorage.getItem('creditType')!;
  public completedSteps: FormGroup;
  public country: string | undefined;
  center!: google.maps.LatLngLiteral;
  public dataCountry: any;
  public activeLang!: string;
  public countryShortName!: string;
  public activeLangUpdate!: string;
  public isCountryValidated!: boolean;
  public requestNumber!: string;
  public uberAprovePrefilter!: boolean;
  public comboData!: DataSelects;
  public canPassStep = false;
  private stepperQueryString: string = '';
  public clicked = false;
  public randomMode = 0;
  private referralId = '';

  hideStepUber = false;

  public editLto = false;

  private stepsRoutesLto = [
    'bienvenida',
    'datos-uber',
    'documentos-principales',
    'documentos-secundarios',
    'mas-informacion',
  ];

  private stepsRoutesDae = [
    'bienvenida',
    'sobre-ti',
    'datos-uber',
    'carga-documentos',
    'mas-informacion',
  ];

  constructor(
    private breakpointObserver: BreakpointObserver,
    private getDataService: GetDataService,
    private requestFormService: RequestFormService,
    private router: Router,
    private dialog: MatDialog,
    private frmBuilder: FormBuilder,
    private mapsInformationService: MapsInformationService,
    private activatedRouter: ActivatedRoute,
    private translate: TranslateService,
    public putDataService: PutDataService,
    private location: Location,
    private hideToolbarService: HideToolbarService
  ) {
    this.activatedRouter.queryParams.subscribe((params) => {
      this.requestNumber = params['requestNumber'];
      this.referralId = params['referallId'];
      this.stepperQueryString = Object.keys(params)
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        )
        .join('&');
    });

    // this.randomMode = this.selectRandomMode(environment.DAE_LEGACY_FORM_MODE) ? 0 : 1;
    this.randomMode = 1;

    this.hideToolbarService.hideToolbarFromFormModeSet = this.randomMode === 1 && !this.legacyCampaign ? true : false;

    // console.log(environment.DAE_LEGACY_FORM_MODE);

    this.stepperOrientation = this.breakpointObserver
      .observe('(min-width: 820px)')
      .pipe(
        map(({ matches }) => {
          this.collapsedSteps = !matches;
          return matches ? 'horizontal' : 'vertical';
        })
      );

    this.completedSteps = this.frmBuilder.group({
      step1: ['', Validators.required],
      step2: ['', Validators.required],
      step3: ['', Validators.required],
      step4: ['', Validators.required],
      step5: ['', Validators.required],
      step6: ['', Validators.required],
    });

    this.translate.setDefaultLang(this.activeLang);

    if (this.requestFormService.getUpdateForm()) {
      this.creditType =
        this.requestFormService.getUpdateForm().creditType.code ===
          CreditType.DAE
          ? CreditTypeId.DAE
          : CreditTypeId.LTO;
      this.canPassStep =
        this.requestFormService.getUpdateForm()?.canPassStepFour;
      this.uberAprovePrefilter =
        this.requestFormService.getUpdateForm().uber.approveUberPrefilter;
    }

    const pathname = window.location.hostname;
    if (pathname === 'msforms.vemo.mx') {
      this.hideStepUber = true;
    }
  }

  testSelectRandomModeWith5000Iterations() {
    const iterations = 5000;
    let countTrue = 0;
    let countFalse = 0;

    for (let i = 0; i < iterations; i++) {
      if (this.selectRandomMode(environment.DAE_LEGACY_FORM_MODE)) {
        countTrue++;
      } else {
        countFalse++;
      }
    }

    console.log(`True count: ${countTrue}`);
    console.log(`False count: ${countFalse}`);
    console.log('Percentage:', (countTrue / iterations) * 100);

  }

  selectRandomMode(percentage: number): boolean {
    return Math.random() * 100 < percentage;
  }

  newWelcomeEvent(event: boolean) {
    console.log(event);
  }

  markStepSaved(step: number, event: boolean) {
    if (event) {
      this.completedSteps.controls[`step${step}`].setValue(true);
      step > 5 ? this.saveRequest() : this.nextStepper(step);
    }
  }

  completeDocument() {
    this.completedSteps.controls['step5'].setValue(true);
  }

  completeSteps(toStep: number) {
    const controls = Object.keys(this.completedSteps.controls);
    if (toStep < 0) {
      controls.forEach((c) => {
        this.completedSteps.controls[c].setValue(true);
        this.stepper.next();
      });
      return;
    }
    const controlsToCompleted = controls.slice(0, toStep);
    controlsToCompleted.forEach((c) => {
      this.completedSteps.controls[c].setValue(true);
      this.stepper.next();
    });
  }

  completeStep() {
    const actualStep = parseInt(sessionStorage.getItem('stepNumber')!);
    this.completeStepForm(actualStep);
  }

  completeStepForm(actualStep: number) {
    if (actualStep > 6) {
      actualStep = 6;
    }
    if (actualStep > 5) {
      this.completeSteps(5);
      return;
    }
    if (actualStep > 3) {
      this.completeSteps(actualStep);
      return;
    }
    this.completeSteps(actualStep);
  }

  nextStepper(step: number) {
    this.stepper.selectedIndex = step;
  }

  sendRequestInit() {
    this.requestValueInit.next(true);
  }
  sendRequestWelcome() {
    this.requestValueWelcome.next(true);
  }
  sendRequestWelcomeLto() {
    this.requestValueWelcomeLto.next(true);
  }
  sendRequestExperience() {
    this.requestValueExperience.next(true);
  }
  sendRequestAboutYouCo() {
    this.requestValueAboutYouCo.next(true);
  }
  sendRequestAboutYou() {
    this.requestValueAboutYou.next(true);
  }
  sendRequestDataUber() {
    this.requestValueDataUber.next(true);
  }
  sendRequestDataUberLto() {
    this.requestValueDataUberLto.next(true);
  }
  sendRequestWhereLive() {
    this.requestValueWhereLiveCo.next(true);
  }
  sendRequestDocuments() {
    this.requestValueDocuments.next(true);
  }
  sendRequestMainDocumentsLto() {
    this.requestValueMainDocumentsLto.next(true);
  }
  sendRequestLoadDocuments() {
    this.requestValueLoadDocuments.next(true);
  }
  sendRequestMoreInformation() {
    this.requestValueMoreInformation.next(true);
  }
  sendRequestDataValidationLto() {
    this.requestValueValidationDataLto.next(true);
  }
  sendRequestSecondaryDocumentsLto() {
    this.requestValueSecondaryDocumentsLto.next(true);
  }
  sendRequestMoreInformationLto() {
    this.requestValueMoreInformationLto.next(true);
  }
  saveRequest() {
    this.openRequestInformationDialog();
  }

  ngOnInit(): void {
    this.activatedRouter.params.subscribe((params) => {
      this.country = params['country'];
      this.activeLang = this.country!;

      if (this.country) {
        this.getCompleteData(this.country.toUpperCase());
      }
    });

    if (this.requestFormService.getUpdateForm()) {
      this.activeLangUpdate = this.requestFormService.getUpdateForm()?.country
        ? this.requestFormService.getUpdateForm()?.country.code.toLowerCase()
        : this.requestFormService
          .getUpdateForm()
          ?.countryCode.code.toLowerCase();

      this.country = this.requestFormService.getUpdateForm()?.country
        ? this.requestFormService.getUpdateForm()?.country.code.toLowerCase()
        : this.requestFormService
          .getUpdateForm()
          ?.countryCode.code.toLowerCase();

      this.getCompleteData(this.activeLangUpdate);
    }

    this.changeLanguage(
      this.requestFormService.getUpdateForm()
        ? this.activeLangUpdate
        : this.activeLang
    );
  }

  public savedSteps: number = 0;
  public collapsedSteps: boolean = false;

  ngAfterViewInit() {
    if (
      this.requestFormService.getUpdateForm() &&
      parseInt(sessionStorage.getItem('stepNumber')!) < 6
    ) {
      setTimeout(() => {
        this.savedSteps = parseInt(sessionStorage.getItem('stepNumber')!);
        this.completeStepForm(this.savedSteps);
      }, 0);
    } else if (
      this.requestFormService.getUpdateForm() &&
      parseInt(sessionStorage.getItem('stepNumber')!) >= 6
    ) {
      setTimeout(() => {
        this.completeStepForm(5);
      }, 0);
    }
  }

  openRequestInformationDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Su solicitud se guardó con exito',
      question: `Gracias por completar el formulario, nos pondremos en contacto con usted a la brevedad.`,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe(() => {
        this.router.navigate(['/busqueda']);
        sessionStorage.clear();
      });
  }

  openCountrySelectionDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    this.dialog
      .open(CountrySelectionComponent, dialogConfig)
      .afterClosed()
      .subscribe((result) => {
        this.mapsInformationService.setCountryInformation(result);
      });
  }

  changeLanguage(host: string) {
    if (host) {
      this.activeLang = host;
      this.translate.use(host);
      sessionStorage.setItem('language', host);
    }
  }

  getCompleteData(value: string) {
    if (this.creditType === CreditTypeId.DAE && this.country === 'mx') {
      this.getDataService.getApplicationsSelectsMx(value).subscribe((resp) => {
        this.comboData = resp;
      });
    }
    if (this.creditType === CreditTypeId.LTO) {
      this.getDataService.getApplicationsSelectsLto(value).subscribe((resp) => {
        this.comboData = resp;
      });
    }
  }

  redirectUrlStepControl(event: StepperSelectionEvent) {
    const country = 'mx';

    if (this.creditType === CreditTypeId.DAE) {
      const stepName =
        this.stepsRoutesDae[event.selectedIndex] ?? this.stepsRoutesDae.at(-1);
      this.location.go(
        `${country}/solicitud/${stepName}`,
        this.stepperQueryString
      );
    }

    if (this.creditType === CreditTypeId.LTO) {
      const stepName =
        this.stepsRoutesLto[event.selectedIndex] ?? this.stepsRoutesLto.at(-1);
      this.location.go(
        `${country}/solicitud/${stepName}`,
        this.stepperQueryString
      );
    }
  }

  openRequestInformationSearchDialog(error: HttpErrorResponse) {
    let errorMessage =
      'Su solicitud no ha sido localizada y/o expiró, favor de verificar sus datos.';

    const errorOldForm = 'The old form is permanently inaccessible'.match(
      error.error.message
    );

    if (errorOldForm) {
      errorMessage = `Su solicitud no ha sido localizada y/o expiró, por favor cargue sus datos nuevamente`;
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = 'min(400px,90%)';
    dialogConfig.maxWidth = 'none';
    dialogConfig.data = {
      title: 'Información de busqueda',
      question: errorMessage,
      errorOldForm,
    };
    this.dialog
      .open(RequestInformationComponent, dialogConfig)
      .afterClosed()
      .subscribe();
  }

  get legacyCampaign(): boolean {
    return environment.CAMPAIGNS_FOR_LEGACY_FORM.includes(this.referralId);
  }
}
